import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  // convertStringToArray,
  throttle
} from '../../../utils';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
// children
import { Case } from '../../../utils/Models';
import Banner from '../../common/Banner';
import EntitySearchBox from '../../common/EntitySearchBox';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import NavigationList from '../../common/NavigationList';
import { newEntities, oldEntities, setCases } from '../actions/actionCreator';
//style
import { setCurrentActiveTab, setLandingActiveTab } from '../../CaseBody/actions/actionCreator';
import './styles.css';

const SelectEntity = (props) => {
  const [messages, setMessages] = useState({});
  const [gdocsTermsMessages, setGdocsTermsMessages] = useState({});
  const [sowMappingToCases, setSowMappingToCases] = useState({});
  const [exitPageJson, setExitPageJson] = useState();
  const [json_ci_caseInfo, setJson_ci_caseInfo] = useState();
  const [currentListCountries, setCurrentListCountries] = useState();
  const [showSowCaseCreationInitiatedModal, setShowSowCaseCreationInitiatedModal] = useState(false);

  let lang = {}
  // let currentLang = ''

  // const translateWord = (word) => {
  //   var currentWord = Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
  //   var convertedArray = convertStringToArray(currentWord);
  //   return convertedArray;
  // }

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    // aemHostClient("/aemData/formData/json_entities")
    // .then(({data, status}) => {
    //   document.title = data.par.page_title_mainTitle.pageHeading;
    //   setState({pageJson: data});
    // });
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_exit-case");
      setExitPageJson(data)
    })();

    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_ci_caseInfo");
      setJson_ci_caseInfo(data.par)
    })();
    return () => {
      // Anything in here is fired on component unmount.
    }
  }, [])

  useEffect(() => {
    props.updateBreadCrumbsState(1);
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_dark-title-bar");
      document.title = `${translations(data.par.static_text_darkTitleBar.createCase)} - ${'HSBC GLCM'}`;
      props.setDarkTitleBarContent(translations(data.par.static_text_darkTitleBar.createCase), true, translations(data.par.static_text_darkTitleBar.caseList), undefined, undefined);
    })();
    getTaxanomyCountry();
  }, []);


  useEffect(() => {
    // let doesConflictExists = false;
    let doesNegotiatedExists = false;
    for (let entityId in props.entities) {
      // if (props.entities[entityId].status !== 'no_conflicts') {
      //   doesConflictExists = true;
      // }
      if (props.entities[entityId].gdocsTerms === 'Negotiated') {
        doesNegotiatedExists = true;
      }
    }
    if (doesNegotiatedExists) {
      setGdocsTermsMessages(prevState => {
        return {

          ...prevState.gdocsTermsMessages,
          "gdocsTerms_conflicts_msg": {
            "content": props.pageJson.par.notification_conflictMessage.message2
          }

        };
      });
    } else if (props.entities && Object.keys(props.entities).length === 0) {
      setGdocsTermsMessages([]);
    } else {
      setGdocsTermsMessages(prevState => {
        let _gdocsTermsMessages = { ...prevState.gdocsTermsMessages };
        delete _gdocsTermsMessages.gdocsTerms_conflicts_msg;
        return {
          ..._gdocsTermsMessages
        };
      });
    }

    // if (doesConflictExists) {
    //   setMessages(prevState => {
    //     return {

    //       ...prevState.messages,
    //       "case_conflicts_msg": {
    //         "content": props.pageJson.par.notification_conflictMessage.message1
    //       }

    //     };
    //   });
    // } else if (props.entities && Object.keys(props.entities).length === 0) {
    //   setMessages([]);
    // } else {
    //   setMessages(prevState => {
    //     let _messages = { ...prevState.messages };
    //     delete _messages.case_conflicts_msg;
    //     return {
    //       ..._messages
    //     };
    //   });
    // }
    // if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
    //   this.getTaxanomyCountry();
    // }
  }, [props]);

  useEffect(() => {
    getTaxanomyCountry();
  }, [props.lang.currentLang.lang]);


  const getTaxanomyCountry = () => {
    (async () => {
      const { data } = await taxonomyHostClient(translations(props.pageJson.par.navigation_list_customerList.countryTaxonomy));
      setCurrentListCountries(data.responseData.classificationNodes)
    })();
  }

  const dontSaveCase = () => {
    lang = props.lang;
    props.resetStore(lang);
    props.history.push("/case-list");
  }

  const saveCase = () => {
    // this action will create case and go back to case list, so we are not adding cases/entities to redux store
    lang = props.lang;
    const entitiesWithNoCaseIds = getEntitiesWithNoCaseIds();
    const addNewCasesPayload = prepareAddNewCasesPayload();
    if (entitiesWithNoCaseIds.length !== 0 && addNewCasesPayload.length !== 0) {
      (async () => {
        const { data } = await eapiClient(props.pageJson.par.button_finish.apiUrl, {
          method: "POST",
          data: JSON.stringify(addNewCasesPayload)
        });
        props.resetStore(lang);
        props.history.push("/case-list");
      })();
    } else {
      props.resetStore(lang);
      props.history.push("/case-list");
    }
  }

  const getSowCreateCasePayload = (newCasePayload) => {
    const payload = {
      multiEntity: Object.keys(sowMappingToCases).map(key => {
        return ({
          partyId: key,
          sow: true,
          sowDetails: {
            name: getSowEntitiesList().find(ent => ent.id === sowMappingToCases[key])["registeredName"],
            value: sowMappingToCases[key]
          },
          caseId: props.entities && props.entities[key] && props.entities[key].caseId,
          inFlightState: props.inFlightCasesState && props.inFlightCasesState[key]
        })
      })
    }
    return payload
  }

  const saveCaseWithSowMapping = (newCasesPayload = {}) => {
    const payload = getSowCreateCasePayload(newCasesPayload)
    sowCreateCase(payload)
  }

  const sowCreateCase = async (payload = {}) => {
    try {
      const apiUrl = '/sows/' + props.sowDetail.sowId + '/createCase'
      const { data } = await eapiClient(apiUrl, { method: 'POST', data: JSON.stringify(payload) })
      if (payload.multiEntity && payload.multiEntity.length < 5) {
        const { formattedCaseCreationResponse = [], responseFromCaseCreation } = data.responseData || {}
        if (data.responseData) {
          const _oldEntity = props.old_Entities !== undefined ? props.old_Entities : [];
          const _newEntity = props.new_Entities !== undefined ? props.new_Entities : [];
          for (const entity of formattedCaseCreationResponse) {
            const { id, entityId, newEntity } = entity;
            if (newEntity) {
              _newEntity.push(entityId)
              props.newEntities(_newEntity)
            } else {
              _oldEntity.push(entityId)
              props.oldEntities(_oldEntity)
            }
            props.updateEntityWithCaseId(entityId, id);
            props.createCase(new Case(entity));
          }
          createAddressAndProduct(responseFromCaseCreation)
        }
      } else {
        setShowSowCaseCreationInitiatedModal(true)
      }
    } catch (error) {
      console.log(error)
    }
    // const { formattedCaseCreationResponse = [], responseFromCaseCreation } = data.responseData || {}
    // if (data.responseData) {
    //   const _oldEntity = props.old_Entities !== undefined ? props.old_Entities : [];
    //   const _newEntity = props.new_Entities !== undefined ? props.new_Entities : [];
    //   for (const entity of formattedCaseCreationResponse) {
    //     const { id, entityId, newEntity } = entity;
    //     if (newEntity) {
    //       _newEntity.push(entityId)
    //       props.newEntities(_newEntity)
    //     } else {
    //       _oldEntity.push(entityId)
    //       props.oldEntities(_oldEntity)
    //     }
    //     props.updateEntityWithCaseId(entityId, id);
    //     props.createCase(new Case(entity));
    //   }
    //   // createAddressAndProduct(responseFromCaseCreation)
    // }
  }

  // const sowCreateCaseV2 = async (payload = {}) => {
  //   const apiUrl = '/cases'
  //   const { data } = await eapiClient(apiUrl, { method: 'POST', data: JSON.stringify((payload.multiEntity && payload.multiEntity) || []) })
  //   const { responseData: formattedCaseCreationResponse } = data || {}
  //   if (data.responseData) {
  //     const _oldEntity = props.old_Entities !== undefined ? props.old_Entities : [];
  //     const _newEntity = props.new_Entities !== undefined ? props.new_Entities : [];
  //     for (const entity of formattedCaseCreationResponse) {
  //       const { id, entityId, newEntity } = entity;
  //       if (newEntity) {
  //         _newEntity.push(entityId)
  //         props.newEntities(_newEntity)
  //       } else {
  //         _oldEntity.push(entityId)
  //         props.oldEntities(_oldEntity)
  //       }
  //       props.updateEntityWithCaseId(entityId, id);
  //       props.createCase(new Case(entity));
  //     }
  //     const { data: responseFromUpdateSowCase } = await eapiClient('/sows/' + props.sowDetail.sowId + '/updateSowForCreatedCase', { method: "PUT" })

  //     const caseId = data.responseData[0].id
  //     const { id: entityId = '' } = (responseFromUpdateSowCase && responseFromUpdateSowCase.responseData && responseFromUpdateSowCase.responseData.entity &&
  //       responseFromUpdateSowCase.responseData.entity.find(e => e.agent)) || {}

  //     const { data: addressAndProductPayloadSowCreatedCase } = await eapiClient(`/sows/${entityId}/getAddressAndProductPayloadForSowCreatedCase/${caseId}`, { method: "PUT", data: JSON.stringify(responseFromUpdateSowCase.responseData) })
  //     if (addressAndProductPayloadSowCreatedCase && addressAndProductPayloadSowCreatedCase.responseData) {
  //       createAddressAndProduct(addressAndProductPayloadSowCreatedCase.responseData)
  //     }
  //   }
  // }

  const createAddressAndProduct = async ({ address = [], glsProduct = [] }) => {
    const apiUrl = '/sows/' + props.sowDetail.sowId + '/createAddressAndProduct'
    const payload = { address, glsProduct }
    const { data } = await eapiClient(apiUrl, { method: 'POST', data: JSON.stringify(payload) })
    if (data && data.product && data.product.responseData) {
      createAccountPool(data.product.responseData)
    }
  }

  const createAccountPool = async (products = [],) => {
    const apiUrl = '/sows/' + props.sowDetail.sowId + '/createAccountPool'
    const payload = products[0] || {}
    const { data } = await eapiClient(apiUrl, { method: 'POST', data: JSON.stringify(payload) })
    if (data.responseData) {
      products && products.forEach(product => {
        getGLSProductSync(product.id, data.responseData)
      })
    }
  }

  const getGLSProductSync = async (glsId = '', accountPools = []) => {
    const apiUrl = '/sows/' + glsId + '/getGLSProductSync'
    const payload = accountPools
    const { data } = await eapiClient(apiUrl, { method: 'PUT', data: JSON.stringify(payload) })
    if (data.responseData) {
      props.setCurrentActiveTab && props.setCurrentActiveTab(0)
      props.history.push('/case-body')
    }
  }

  const finish = () => {
    const entitiesWithNoCaseIds = getEntitiesWithNoCaseIds();
    const addNewCasesPayload = prepareAddNewCasesPayload();
    if (props.isClientImplementationManager) {
      saveCaseWithSowMapping(addNewCasesPayload)
    }
    else if (Object.keys(props.entities).length !== 0 && entitiesWithNoCaseIds.length !== 0 && addNewCasesPayload.length !== 0) {
      (async () => {
        const { data } = await eapiClient(props.pageJson.par.button_finish.apiUrl, {
          method: "POST",
          data: JSON.stringify(addNewCasesPayload)
        });
        let _oldEntity = props.old_Entities !== undefined ? props.old_Entities : [];
        let _newEntity = props.new_Entities !== undefined ? props.new_Entities : [];
        for (let i = 0; i < data.responseData.length; i++) {
          let { id, entityId, newEntity } = data.responseData[i];
          if (newEntity) {
            _newEntity.push(entityId)
            props.newEntities(_newEntity)
          } else {
            _oldEntity.push(entityId)
            props.oldEntities(_oldEntity)
          }
          props.updateEntityWithCaseId(entityId, id);
          props.createCase(new Case(data.responseData[i]));
        }
        props.setCases({ cases: data.responseData });
        props.history.push('/case-body');
      })();
    } else if (Object.keys(props.entities).length !== 0) {
      props.history.push("/case-body");
    }
  }

  const checkForCaseConflicts = () => {
    // var doesConflictExists = false;
    // for (var entityId in props.entities) {
    //   if (props.entities[entityId].status !== 'no_conflicts') {
    //     doesConflictExists = true;
    //   }
    // }
    return (Object.keys(props.entities).length === 0);
  }

  const getEntitiesWithNoCaseIds = () => {
    return (Object.keys(props.entities)).filter(entityId => {
      return props.entities[entityId].caseId === undefined;
    });
  }

  const prepareAddNewCasesPayload = () => {
    const multiEntity = (Object.keys(props.entities)).filter(entityId => {
      return props.entities[entityId].caseId === undefined
    }).map(entityId => {
      return {
        partyId: entityId,
        caseId: props.entities[entityId].caseId,
        inFlightState: props.inFlightCasesState[entityId]
      };
    }) || [];
    return { multiEntity }
  }

  const toNextpage = () => {
    const entitiesWithNoCaseIds = getEntitiesWithNoCaseIds();
    const addNewCasesPayload = prepareAddNewCasesPayload();
    if (Object.keys(props.entities).length !== 0 && entitiesWithNoCaseIds.length !== 0 && addNewCasesPayload.length !== 0) {
      (async () => {
        const { data } = await eapiClient(props.pageJson.par.button_finish.apiUrl, {
          method: "POST",
          data: JSON.stringify(addNewCasesPayload)
        });
        let _oldEntity = props.old_Entities !== undefined ? props.old_Entities : [];
        let _newEntity = props.new_Entities !== undefined ? props.new_Entities : [];
        for (let i = 0; i < data.responseData.length; i++) {
          var { id, entityId, newEntity } = data.responseData[i];
          if (newEntity) {
            _newEntity.push(entityId)
            props.newEntities(_newEntity)
          } else {
            _oldEntity.push(entityId)
            props.oldEntities(_oldEntity)
          }
          props.updateEntityWithCaseId(entityId, id);
          props.createCase(new Case(data.responseData[i]));
        }
        props.setCases({ cases: data.responseData });
        props.history.push("/create-a-case/add-account");
      })();
    } else if (Object.keys(props.entities).length !== 0) {
      props.history.push("/create-a-case/add-account");
    }
  }

  const getSelectedEntity = (selectedEntity) => {
    props.createEntity(new Entity(selectedEntity));
  }

  const deleteEntity = (entityId) => {
    props.deleteEntity(entityId);
    props.clearInFlightCasesStateForAllEntites();
    for (let caseId in props.cases) {
      if (props.cases[caseId].entityId === entityId) {
        props.deleteCase(caseId);
      }
    }
    if (props.isClientImplementationManager) {
      const newSowMappingToCases = sowMappingToCases
      delete newSowMappingToCases[entityId]
      setSowMappingToCases(newSowMappingToCases)
    }

  }

  const getSowEntitiesList = () => {
    return (props.sowDetail && props.sowDetail.entity) || []
  }

  const handleSowMappingValidation = () => {
    if (isValidObject(sowMappingToCases) && isValidObject(props.entities)) {
      return Object.values(sowMappingToCases).length !== Object.values(props.entities).length
    }
  }

  const isValidObject = (obj) => {
    return (obj !== undefined || obj !== null) && typeof obj === "object" && !Array.isArray(obj)
  }

  const handleShowSowCaseCreationInitiatedModal = () => {
    setShowSowCaseCreationInitiatedModal(!showSowCaseCreationInitiatedModal)
    props.resetStore(props.lang);
    props.history.push("/case-list");
    props.setLandingActiveTab(0)
  }

  let messagesJsx = Object.keys(messages).map((messageId, index) => (
    <Banner key={index} bannerType="warning">
      {translations(messages[messageId].content)}
    </Banner>))
  let gdocsTermsMessagesJsx = Object.keys(gdocsTermsMessages).map((gdocsTermsMessagesId, index) => (
    <Banner key={index} bannerType="warning">
      {translations(gdocsTermsMessages[gdocsTermsMessagesId].content)}
    </Banner>
  ))
  let jsx = (<h3>Loading.....</h3>);
  if (props.pageJson && exitPageJson && json_ci_caseInfo) {
    jsx = (<div className="selectcustomercontainer">
      <h5>{translations(props.pageJson.par.static_text_guidanceTextOne.text)}</h5>
      <ul>
        <li><h5>{translations(props.pageJson.par.static_text_guidanceTextTwo.text).split(',')[0].split('[')[1]}<a href='https://sharepoint.global.hsbc/sites/GLCMDocs/Shared%20Documents/Requesting%20a%20Pack%20Page/GDocs%20Negotiated%20Customer%20List.xlsx'> {translations(props.pageJson.par.static_text_guidanceTextTwo.text).split(',')[1]}</a>
          {translations(props.pageJson.par.static_text_guidanceTextTwo.text).split(',')[2]} <a href='https://sharepoint.global.hsbc/sites/GLCMDocs/Shared%20Documents/Requesting%20a%20Pack%20Page/Negotiation%20Process%20-%20Live.pdf' rel="noopener noreferrer" target="_blank">{translations(props.pageJson.par.static_text_guidanceTextTwo.text).split(',')[3]}</a> {translations(props.pageJson.par.static_text_guidanceTextTwo.text).split(',')[4].split(']')[0]}</h5></li>
        <li><h5>{translations(props.pageJson.par.static_text_guidanceTextThree.text1)}<a href='https://sharepoint.global.hsbc/sites/GLCMDocs/GDMPortal/Shared%20Documents/HSBC%20Global%20Documentation%20Pack%20Request%20-%20Live%20(Portal).pdf' rel="noopener noreferrer" target="_blank"> {translations(props.pageJson.par.static_text_guidanceTextThree.text2)}</a>.</h5></li>
        <li>
          <h5>
            {translations(props.pageJson.par.static_text_guidanceTextUS.text).split(',')[0].split('[')[1]}&nbsp;
            <a href='https://sharepoint.global.hsbc/sites/GLCMDocs/US%20GPS%20Terms/US%20GPS%20Terms.pdf' target='_blank'>
              {translations(props.pageJson.par.static_text_guidanceTextUS.text).split(',')[1]}
            </a>
            {translations(props.pageJson.par.static_text_guidanceTextUS.text).split(',')[2].split(']')[0]}
          </h5>
        </li>
      </ul>
      <h5>{translations(props.pageJson.par.static_text_guidanceTextFour.text)}</h5>
      <h5>{translations(props.pageJson.par.static_text_guidanceTextFive.text1)}</h5>
      <h5>{translations(props.pageJson.par.static_text_guidanceTextFive.text2)}</h5>
      <h5>{translations(props.pageJson.par.static_text_guidanceTextFive.text3)}</h5>
      <h5>{translations(props.pageJson.par.static_text_guidanceTextFive.text4)}</h5>

      <h2>{translations(props.pageJson.par.page_title_mainTitle.pageHeading)}</h2>

      <div>
        {(props.isClientImplementationManager && props.sowDetail && props.sowDetail.entity && props.sowDetail.entity.length)
          ? translations(json_ci_caseInfo.static_text_caseCreationInfo.legal_Entity_label)
          : translations(props.pageJson.par.page_title_mainTitle.descriptionText)}
      </div>

      <SowEntityList sowEntities={getSowEntitiesList()} show={props.isClientImplementationManager}></SowEntityList>

      {(props.isClientImplementationManager && props.sowDetail && props.sowDetail.entity && props.sowDetail.entity.length)
        ? <h5 style={{ marginTop: "15px" }}>
          {translations(json_ci_caseInfo.static_text_caseCreationInfo.select_Entity_desc)}
        </h5> : null
      }

      <EntitySearchBox
        setSelectedOptions={getSelectedEntity}
        AddscustomerTitle={translations(props.pageJson.par.type_ahead_customerSearch.title)}
        createNewEntityLinkRoute="/create-a-case/create-new-entity"
        maxLength={props.pageJson.par.type_ahead_customerSearch.max || 70}
        lang={props.lang}
        addText={props.pageJson.par.type_ahead_customerSearch.addText} />
      <div className="banners-area">
        {messagesJsx}
      </div>
      <div className="banners-area">
        {gdocsTermsMessagesJsx}
      </div>
      <NavigationList cases={props.cases}
        entities={props.entities}
        history={props.history}
        countryList={currentListCountries}
        statusOption={props.pageJson.par.navigation_list_customerList.status}
        gdocsTerms1={props.pageJson.par.navigation_list_customerList.gdocs_Terms1}
        gdocsTerms2={props.pageJson.par.navigation_list_customerList.gdocs_Terms2}
        gdocsTerms3={props.pageJson.par.navigation_list_customerList.gdocs_Terms3}
        listtype="custVersion"
        deleteEntity={deleteEntity}
        sowEntities={getSowEntitiesList()}
        handleSowMappingToCases={(sowEntityId, entityId) => {
          const newSowMappingToCases = { ...sowMappingToCases }
          newSowMappingToCases[entityId] = sowEntityId
          setSowMappingToCases(newSowMappingToCases)
        }}
        sowMappingToCases={sowMappingToCases}
        isClientImplementationManager={props.isClientImplementationManager}
        getSowMappingToCaseOptions={() => {
          return getSowEntitiesList()
        }}
      />
      <div id="btnwrapperid" className={props.entities.length === 0 ? 'btnWrapper' : 'btnWrapper setbtnpadd'}>
        <div className="rightbtn">
          <button
            disabled={props.isClientImplementationManager ? handleSowMappingValidation() : checkForCaseConflicts()}
            onClick={() => { throttle(finish, 5000) }}
            className={props.isClientImplementationManager ? handleSowMappingValidation() : checkForCaseConflicts() ? 'btn btn-primary btnmrg btndisable' : 'btn btn-primary btnmrg'}
          >
            {translations(props.pageJson.par.button_finish.text)}
          </button>
          {
            props.isClientImplementationManager ? null :
              <button
                onClick={toNextpage}
                disabled={checkForCaseConflicts()}
                className={checkForCaseConflicts() ? 'btn btn-primary btndisable' : 'btn btn-primary btnbg'}
              >
                <b>{translations(props.pageJson.par.button_nextAccounts.textNext)}:</b> {translations(props.pageJson.par.button_nextAccounts.text)}
              </button>
          }
        </div>
      </div>
      <div className="gdocs-clear-float"></div>
      <ExistCaseModal showDialog={props._showDarkTitleBarActionModal}
        toggleDialog={props.hideDarkTitleBarActionModal}
        bsClass="exist-case-dialog"
        modalTitle={translations(exitPageJson.par.page_title_mainTitle.pageHeading)}
        modalContent={translations(exitPageJson.par.page_title_mainTitle.descriptionText)}
        _onCancel={props.hideDarkTitleBarActionModal}
        _onNo={dontSaveCase}
        _onYes={saveCase}
        btnLabels={[translations(exitPageJson.par.button_cancelCase.text), translations(exitPageJson.par.button_deleteCase.text), translations(exitPageJson.par.button_saveCase.text)]} />
      {props.pageJson.par.modal_SowToGdocsCaseCreation ? <SowCaseCreationModal showDialog={showSowCaseCreationInitiatedModal}
        toggleDialog={handleShowSowCaseCreationInitiatedModal}
        bsClass="exist-case-dialog"
        modalTitle={translations(props.pageJson.par.modal_SowToGdocsCaseCreation.title)}
        modalContent={translations(props.pageJson.par.modal_SowToGdocsCaseCreation.helptext)}
        _onYes={handleShowSowCaseCreationInitiatedModal}
        btnLabels={[translations(props.pageJson.par.modal_SowToGdocsCaseCreation.redBtn)]} /> : null}
    </div>);
  }
  return (
    <div>
      {jsx}
    </div>
  );

}

const SowEntityList = ({ sowEntities = [], show = false }) => {
  return show ? <article className='create-case-sow-entity-list'>
    {sowEntities.map((ent, index) => {
      return (
        <section key={index} className='list-item'>{ent.registeredName + " - " + ((ent.countryOfIncorporation && ent.countryOfIncorporation.name) || '')}</section>
      )
    })}
  </article> : null
}

const mapStateToProps = (state) => ({
  new_Entities: state.newEntities,
  old_Entities: state.oldEntities,
  lang: state.lang,
  sowDetail: state.sowEntities && state.sowEntities.savedSow
})

const mapDispatchToProps = dispatch => {
  return {
    newEntities: newEntity => {
      dispatch(newEntities(newEntity))
    },
    oldEntities: oldEntity => {
      dispatch(oldEntities(oldEntity))
    },
    setCurrentActiveTab: tabIndex => {
      dispatch(setCurrentActiveTab(tabIndex))
    },
    setCases: ({ cases, entities }) => {
      dispatch(setCases(cases, entities));
    },
    setLandingActiveTab: (activeTabId) => {
      dispatch(setLandingActiveTab(activeTabId));
    }
  }
}

SelectEntity.propTypes = {
  new_Entities: PropTypes.object,
  old_Entities: PropTypes.object,
  lang: PropTypes.object,
  history: PropTypes.object,
  sowDetail: PropTypes.object,
  pageJson: PropTypes.object,
  cases: PropTypes.object,
  isClientImplementationManager: PropTypes.func,
  entities: PropTypes.object,
  setCurrentActiveTab: PropTypes.func,
  resetStore: PropTypes.func,
  _showDarkTitleBarActionModal: PropTypes.func,
  hideDarkTitleBarActionModal: PropTypes.func,
  createEntity: PropTypes.func,
  deleteCase: PropTypes.func,
  deleteEntity: PropTypes.func,
  clearInFlightCasesStateForAllEntites: PropTypes.func,
  createCase: PropTypes.func,
  updateEntityWithCaseId: PropTypes.func,
  oldEntities: PropTypes.func,
  newEntities: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectEntity)
// there is some difference in response data of entity in create and edit so using different Entity Modal
// below one is used when picking up entity from search list
const Entity = ({ id, entityId, entityName, status, gdocsTerms, countryOfFormation }) => {
  return {
    id,
    entityId,
    entityName,
    cof: countryOfFormation,
    caseId: undefined,
    status,
    gdocsTerms,
  }
}


//Exit case Modal
const ExistCaseModal = ({ showDialog, toggleDialog, bsClass, modalTitle, modalContent, _onCancel, _onNo, _onYes, btnLabels }) => (
  <Modal show={showDialog} onClose={toggleDialog} bsClass={bsClass}>
    <ModalHeader title={modalTitle} />
    <ModalBody>
      {modalContent}
    </ModalBody>
    <ModalFooter>
      <button className="gdocs-btn-default cancel-btn" onClick={_onCancel} >{btnLabels[0]}</button>
      <button className="gdocs-btn-default no-btn" onClick={_onNo} >{btnLabels[1]}</button>
      <button className="gdocs-btn-primary yes-btn" onClick={_onYes} >{btnLabels[2]}</button>
    </ModalFooter>
  </Modal>
)

const SowCaseCreationModal = ({ showDialog, toggleDialog, bsClass, modalTitle, modalContent, _onYes, btnLabels }) => (
  <Modal show={showDialog} onClose={toggleDialog} bsClass={bsClass}>
    <ModalHeader title={modalTitle} />
    <ModalBody>
      {modalContent}
    </ModalBody>
    <ModalFooter>
      <button className="gdocs-btn-primary yes-btn" onClick={_onYes} >{btnLabels[0]}</button>
    </ModalFooter>
  </Modal>
)


// WEBPACK FOOTER //
// ./src/components/createAcase/SelectEntity/SelectEntity.js